import React from 'react';

import Header from './Header';
import PlatformSection from './PlatformSection';
import OurProductsSection from './OurProductsSection';
import WeAreSection from './WeAreSection';
import WhySection from './WhySection';
// import AdvantagesSection from "./AdvantagesSection";
// import CommentSection from "./CommentSection";
import PartnersSection from './PartnersSection';
import ContactsSection from './ContactsSection';
import Footer from './Footer';
import SecuritySection from './SecuritySection';

export default function MainLandingPage() {
  return (
    <>
      <Header />
      <main>
        <PlatformSection />
        <OurProductsSection />
        <WeAreSection />
        <PartnersSection />
        <WhySection />
        <SecuritySection />
        {/* <AdvantagesSection /> */}
        {/* <CommentSection /> */}
        <ContactsSection />
      </main>
      <Footer className="footer-main" />
    </>
  );
}
